import { Route, Switch, Redirect } from 'react-router-dom';

import Location from './pages/Location';
import NotFound from './pages/NotFound';

export const BASE_PATH = process.env.REACT_APP_PUBLIC_URL || '/apg-ecommerce-platform/apg-product-finder/';
export const LOCATION_PATH = `/location`;
export const PRODUCT_PATH = `${LOCATION_PATH}/product`;

export const Navigator = () => (
    <Switch>
        <Route render={() => <Redirect to={LOCATION_PATH} />} exact path="/" />
        <Route component={Location} path={LOCATION_PATH} exact />
        <Route
            path={PRODUCT_PATH}
            render={({ location }) => <Location location={location as unknown as Location} />}
            exact
        />
        <Route component={NotFound} path="*" exact />
    </Switch>
);
